<div class="recent-orders">
    <div class="title-buttons d-flex justify-content-between align-items-center">
        <strong>Clients & Partners</strong>
        <button (click)="addPartner()" class="button button-submit button-md"> Add Partner </button>
    </div>
    <br />
    <div class="table-responsive">
        <table class="table table-striped" id="clients-partners-table">
            <thead>
                <tr class="first last">
                    <th>Logo</th>
                    <th>Partner Name</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody *ngIf="loading">
                <tr>
                    <td colspan="3" style="text-align: center">Loading ...</td>
                </tr>
            </tbody>
            <tbody *ngIf="!loading && clientPartners.length === 0">
                <tr>
                    <td colspan="3" style="text-align: center">No clients or partners found</td>
                </tr>
            </tbody>
            <tbody *ngIf="!loading && clientPartners.length > 0">
                <tr *ngFor="let partner of clientPartners">
                    <td>
                        <img *ngIf="partner.logoPath" [src]="partner.logoPath" [alt]="partner.clientPartnerName" style="max-height: 60px; max-width: 100px; object-fit: contain;" />
                        <span *ngIf="!partner.logoPath" class="text-muted">No logo</span>
                    </td>
                    <td>{{ partner.clientPartnerName }}</td>
                    <td>
                        <button class="btn btn-sm btn-outline-primary me-2" (click)="viewDetails(partner)">
                            View
                        </button>
                        <button class="btn btn-sm btn-outline-danger" (click)="confirmDelete(partner)">Delete</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<!-- View Details Modal -->
<ng-container *ngIf="showDetailsModal">
    <div class="modal show" style="display: block; z-index: 9999;" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header" style="background: #0c812c; color: #fff;">
                    <h5 class="modal-title">Partner Details</h5>
                    <button type="button" class="btn-close btn-close-white" (click)="closeDetails()"></button>
                </div>
                <div class="modal-body text-center">
                    <div *ngIf="loadingDetails" class="py-4">
                        <p>Loading details...</p>
                    </div>
                    <div *ngIf="!loadingDetails && selectedPartner">
                        <img *ngIf="selectedPartner.logoPath" [src]="selectedPartner.logoPath" [alt]="selectedPartner.clientPartnerName" class="mb-3" style="max-height: 150px; max-width: 250px; object-fit: contain;" />
                        <h4>{{ selectedPartner.clientPartnerName }}</h4>
                        <p class="text-muted">ID: {{ selectedPartner.id }}</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="closeDetails()">Close</button>
                    <button type="button" class="btn btn-primary" (click)="editFromModal()">Edit</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show" style="z-index: 9998;"></div>
</ng-container>

<!-- Delete Confirmation Modal -->
<ng-container *ngIf="showDeleteModal">
    <div class="modal show" style="display: block; z-index: 9999;" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Confirm Delete</h5>
                    <button type="button" class="btn-close" (click)="cancelDelete()"></button>
                </div>
                <div class="modal-body">
                    Are you sure you want to delete <strong>{{ partnerToDelete?.clientPartnerName }}</strong>?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="cancelDelete()">Cancel</button>
                    <button type="button" class="btn btn-danger" (click)="deletePartner()">Delete</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show" style="z-index: 9998;"></div>
</ng-container>
